import React from 'react'
import { LuCompass, LuLayers, LuMap, LuRefreshCcw, LuTarget, LuTrendingUp } from 'react-icons/lu'

export default function Discovery() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Surge Discovery Models</h3>
            <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Scientific. Psychological. Practical. Transformational.</p>
            <div className='mt-[20px] md:mt-[48px] grid lg:grid-cols-2 md:w-11/12 mx-auto gap-[12px] md:gap-[24px] text-start'>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#FDF2F8]'>
                        <LuCompass className='text-[28px] md:text-[37px] text-[#E60076]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Passion Compass</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Find what energizes you</p>
                    </div>
                </div>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#EFF6FF]'>
                        <LuTrendingUp className='text-[28px] md:text-[37px] text-[#155DFC]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Capability Curve</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Awareness → Skill → Confidence → Execution</p>
                    </div>
                </div>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#FAF5FF]'>
                        <LuLayers className='text-[28px] md:text-[37px] text-[#9810FA]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Clarity Pyramid</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Identity → Direction → Action</p>
                    </div>
                </div>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#FFF7ED]'>
                        <LuRefreshCcw className='text-[28px] md:text-[37px] text-[#F54900]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Persistence Engine</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Daily Sparks → Weekly Reviews → Monthly Growth</p>
                    </div>
                </div>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#FEF2F2]'>
                        <LuTarget className='text-[28px] md:text-[37px] text-[#E7000B]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Purpose Grid</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Meaning & Alignment Map</p>
                    </div>
                </div>
                <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center'>
                    <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#F0FDF4]'>
                        <LuMap className='text-[28px] md:text-[37px] text-[#00A63E]' />
                    </div>
                    <div>
                        <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The Skill Map</p>
                        <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Beginner → Capable → Confident → Career-Ready</p>
                    </div>
                </div>
                <div className='lg:col-span-2'>
                    <div className='p-[10px] md:px-[20px] md:py-[25px] rounded-[14px] md:rounded-[25px] border border-[#DCDCDC] flex gap-[16px] items-center lg:w-[602px] mx-auto'>
                        <div className='flex justify-center items-center size-[54px] md:size-[74px] shrink-0 rounded-[12px] md:rounded-[19px] bg-[#ECFEFF]'>
                            <LuRefreshCcw className='text-[28px] md:text-[37px] text-[#0092B8]' />
                        </div>
                        <div>
                            <p className='text-[#101828] text-[16px] md:text-[20px] font-semibold'>The 3C Loop</p>
                            <p className='mt-[4px] text-[#4A5565] font-normal text-[12px] md:text-[16px]'>Clarity → Confidence → Capability → Repeat</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
